export const CardElementStyle = {
    base: {
        fontSize: '1.1em',
        iconColor: '#18521F',
        fontWeight: 'bold',
        padding: '12px'
    }
};
